import { defineMessages } from 'react-intl';

const messages = defineMessages({
  successHeader: {
    id: 'App.SecondaryLeaseApplication.SuccessHeader',
    defaultMessage: 'Success',
  },
  progressSuccessDescription: {
    id: 'App.SecondaryLeaseApplication.ProgressSuccessDescription',
    defaultMessage: 'Lease application saved successfully.',
  },
  completionSuccessDescription: {
    id: 'App.SecondaryLeaseApplication.CompletionSuccessDescription',
    defaultMessage: 'Lease application completed successfully.',
  },
  errorHeader: {
    id: 'App.SecondaryLeaseApplication.errorHeader',
    defaultMessage: 'Error',
  },
  completeDocumentTitle: {
    id: 'App.SecondaryLeaseApplication.CompleteDocument.Title',
    defaultMessage: 'Complete Document',
  },
  completeDocumentSubtitle: {
    id: 'App.SecondaryLeaseApplication.CompleteDocument.Subtitle',
    defaultMessage: 'Send for signature',
  },
  completeDocumentDescription: {
    id: 'App.SecondaryLeaseApplication.CompleteDocument.Description',
    defaultMessage:
      "Send the form to the applicant's portal for electronic signing. " +
      'They will receive a text message and email notifying them of the change. ' +
      "If they don't yet have an account they'll also receive and invitation to join.",
  },
  saveAndCompleteButton: {
    id: 'App.SecondaryLeaseApplication.CompleteDocument.SaveAndComplete',
    defaultMessage: 'Save & Complete',
  },
  saveAndCompleteDescription: {
    id: 'App.SecondaryLeaseApplication.CompleteDocument.SaveAndCompleteDescription',
    defaultMessage:
      'This will finalize the document and save your changes without sending it for signature.',
  },
  sendForSignatureButton: {
    id: 'App.SecondaryLeaseApplication.CompleteDocument.SendForSignature',
    defaultMessage: 'Send for Signature',
  },
  completeConfirmation: {
    id: 'App.SecondaryLeaseApplication.CompleteDocument.CompleteConfirmation',
    defaultMessage: 'Are you sure you want to complete this application?',
  },
});

export default messages;
